<template>
  <div>
    <v-btn @click="abrirFormulario()" class="mx-2" fab dark small color="darkGrey">
      <v-icon color="white" dark>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      v-model="abrirModal"
      max-width="500px"
      @keydown.esc="cancelar()"
      @keydown.enter="gerenciar()"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="11">
              <span class="headline">{{exibirTituloCorretoDoPopup}}
                <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }" >
                     <v-icon small class="ml-2" color="error" v-on="on" v-bind="attrs">mdi-alert-octagon</v-icon>
                    </template>
                    <span>O domínio do cliente precisa ser igual o domínio das contas do workspace que deseja aplicar</span>
                </v-tooltip>
              </span>
            </v-col>
            <v-col cols="1">
              <v-icon color="black" @click="abrirModal = false">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col md="12" xs="12" sm="12">
                  <v-text-field
                    v-model="usuario.nome"
                    label="Nome"
                    id="nome"
                    :rules="[campoObrigatorioRules]"
                    required
                    validate-on-blur
                  ></v-text-field>
                </v-col>

                <v-col md="12" xs="12" sm="12">
                  <v-text-field
                    v-model="usuario.dominio"
                    label="Domínio"
                    :rules="[campoObrigatorioRules, dominioRules]"
                    hint="Exemplo: seudominio.com.br"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="12" xs="12" sm="12" v-if="mostrarCampoStatus">
                  <v-select v-model="usuario.status" :items="selectUsuario" label="status"></v-select>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="6" class="text-start">
                      <v-btn
                        @click="cancelar()"
                        :disabled="carregando"
                        tile
                        color="error"
                      >Cancelar</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-end">
                      <v-btn
                        @click="gerenciar()"
                        min-width="90"
                        :loading="carregando"
                        tile
                        color="primary"
                      >Salvar</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { enviar, editar } from "../../mixins/RequisicaoMixin.js";
import { headersPadrao } from "../../mixins/HeadersMixin.js";
import {
  tratamentoDeDominios,
  validarDominios
} from "../../mixins/validacaoFormularioMixin";

export default {
  props: {
    usuarioEditado: {
      type: Object
    },
    urlPost: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      mostrarSenha: false,
      mostrarCampoStatus: false,
      requisicao: "POST",
      usuario: {
        nome: "",
        dominio: "",
        status: "Ativado"
      },
      campoObrigatorioRules: value => !!value || "Este campo é obrigatório.",
      dominioRules: d => (d = this.validarDominio(d)),

      selectUsuario: ["Ativo", "Inativo"],
      selectPerfil: ["Administrador", "Revendedor"],
      abrirModal: false,
      carregando: false
    };
  },
  methods: {
    salvarCliente() {
      const cabecalho = headersPadrao();
      const formatarDominio = this.dominiosFormatados(this.usuario.dominio);

      const usuarioParaEnviar = {
        dominio: formatarDominio,
        nome: this.usuario.nome
      };
      enviar(this.urlPost, cabecalho, usuarioParaEnviar)
        .then(resposta => {
          this.$emit("carregarDados", resposta);
          this.$store.commit("sucesso", "Usuário salvo com sucesso.");
          this.abrirModal = false;
        })
        .catch(erro => {
          if(erro.request.status == 400){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage);
            this.$store.commit("erro");
          }else this.$store.commit("erro", "Erro ao salvar cliente.")
        })
        .finally(() => (this.carregando = false));
    },
    editarCliente() {
      const cabecalho = headersPadrao();
      const urlPorTipo = `${this.urlPost}/${this.usuario.id}`;
      const status = this.trocarStatusDeTextoParaBollean(this.usuario);
      this.usuario.status = status;
      editar(urlPorTipo, cabecalho, this.usuario)
        .then(resposta => {
          this.$emit("carregarDados", resposta);
          this.$store.commit("sucesso", "Usuário salvo com sucesso.");
          this.abrirModal = false;
        })
        .catch(erro => {
          if(erro.request.status == 400){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage);
            this.$store.commit("erro");
          }else this.$store.commit("erro", "Erro ao editar cliente.")
        })
        .finally(() => {
          this.carregando = false;
          this.requisicao = "POST";
        });
    },
    validarDominio(dominio) {
      const validacao = validarDominios(dominio);
      if (validacao === false) {
        this.usuario.dominio = "";
      }
      return true;
    },

    dominiosFormatados(dominio) {
      if (dominio == undefined) return (dominio = "");
      else {
        const dominioFormatado = tratamentoDeDominios(dominio);
        return dominioFormatado;
      }
    },
    gerenciar() {
      if (this.$refs.form.validate()) {
        this.carregando = true;
        if (this.requisicao === "PUT") {
          this.editarCliente();
        } else {
          this.salvarCliente();
        }
      }
    },
    abrirFormulario() {
      this.usuario = {
        email: "",
        nome: "",
        papel: "",
        senha: ""
      };
      this.mostrarCampoStatus = false;
      this.abrirModal = true;
      this.mudarFocoDoComponente();
    },
    mudarFocoDoComponente() {
      setTimeout(() => {
        document.getElementById("nome").focus();
      }, 50);
    },
    trocarStatusDeBooleanParatexto(usuario) {
      if (usuario.status === true) {
        return (usuario.status = "Ativo");
      }
      return (usuario.status = "Inativo");
    },
    trocarStatusDeTextoParaBollean(usuario) {
      if (usuario.status === "Ativo") {
        return (usuario.status = true);
      }
      return (usuario.status = false);
    },
    cancelar(){
      this.abrirModal = false;
      this.$refs.form.reset();
    }
  },
  computed: {
    exibirTituloCorretoDoPopup(){
      if(this.usuario.id) return "Editar Cliente";
      else return "Novo Cliente";
    }
  },
  watch: {
    usuarioEditado(newVal) {
      this.usuario = newVal;
      this.requisicao = "PUT";
      this.mostrarCampoStatus = true;
      this.abrirModal = true;
      this.trocarStatusDeBooleanParatexto(this.usuario);
      this.mudarFocoDoComponente();
    }
  }
};
</script>